export default "__VITE_ASSET__XBpek8I2a_ud6cI3DMNQMA__"